
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("JQEJY", function(module, exports) {
$parcel$export(module.exports, "PageCatchupPopupForPageHistory", () => (parcelRequire("86vQj")).PageCatchupPopupForPageHistory);
$parcel$export(module.exports, "FilterComponent", () => (parcelRequire("hPavA")).FilterComponent);
// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $42omo = parcelRequire("42omo");


var $8C5kA = parcelRequire("8C5kA");


var $9PrGG = parcelRequire("9PrGG");


var $jmjWc = parcelRequire("jmjWc");


var $gL2Cx = parcelRequire("gL2Cx");


var $86vQj = parcelRequire("86vQj");


var $hPavA = parcelRequire("hPavA");

const $f625d855ba7548b9$var$AISummarizeButtonPlaceholderWithText = ()=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9PrGG.AISummarizeButtonPlaceholder), {
        summarizeText: intl.formatMessage((0, $gL2Cx.i18n).catchUpButtonText)
    });
};

const $f625d855ba7548b9$export$c463287b61deee24 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "DS85o",
    name: "PageCatchupComponent",
    loader: async ()=>(await Promise.resolve((parcelRequire("4RbVT")))).PageCatchupComponentWithErrorBoundary
});

const $f625d855ba7548b9$export$b8934fe6f5a65359 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ZVEMJ",
    name: "PageCatchupPopup",
    loader: async ()=>(await Promise.resolve((parcelRequire("gL2Cx")))).PageCatchupPopupComponent,
    loading: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f625d855ba7548b9$var$AISummarizeButtonPlaceholderWithText, null)
});
module.exports["PageCatchupComponent"] = $f625d855ba7548b9$export$c463287b61deee24;

});

parcelRegister("gL2Cx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $lGgRw = parcelRequire("lGgRw");


var $ccHMk = parcelRequire("ccHMk");


var $6f0Oj = parcelRequire("6f0Oj");

var $ecnYn = parcelRequire("ecnYn");


var $inPa6 = parcelRequire("inPa6");


var $3gadb = parcelRequire("3gadb");


var $ly2zj = parcelRequire("ly2zj");


var $4RbVT = parcelRequire("4RbVT");





var $dPJCf = parcelRequire("dPJCf");

const $619d61f42437d205$var$useOpenPageCatchupParam = (0, $dPJCf.createSingleQueryParamHook)('openContentCatchup');
const $619d61f42437d205$export$a82675333a170ad7 = (isOpen, setIsOpen, selectedVersions)=>{
    const [hasSeen, setHasSeen] = (0, $42omo.useState)(false);
    const isOpenPageCatchupQueryParamValid = $619d61f42437d205$var$useOpenPageCatchupParam() === 'true';
    const hasSelectedVersions = selectedVersions && selectedVersions.size > 1;
    (0, $42omo.useEffect)(()=>{
        if (!isOpen && isOpenPageCatchupQueryParamValid && !hasSeen && hasSelectedVersions) {
            setIsOpen(true);
            setHasSeen(true);
        }
    }, [
        isOpen,
        setIsOpen,
        isOpenPageCatchupQueryParamValid,
        hasSeen,
        setHasSeen,
        hasSelectedVersions
    ]);
};


const $3d9eb45e9938578d$export$a7357cdd1f0b0168 = (0, $cgtv4.defineMessages)({
    catchUpButtonText: {
        id: "page-catchup.catchup.button.text",
        defaultMessage: "Summarize differences"
    }
});
const $3d9eb45e9938578d$var$ContentWidthStyles = (0, $ecnYn.xcss)({
    width: '500px'
});
const $3d9eb45e9938578d$export$93a2b98265b32e4b = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, isDisabled: isDisabled, selectedVersions: selectedVersions, contentPath: contentPath })=>{
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const intl = (0, $8C5kA.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $619d61f42437d205$export$a82675333a170ad7)(isOpen, setIsOpen, selectedVersions);
    const onClick = ()=>{
        setIsOpen(!isOpen);
        if (!isOpen) createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'pageCatchup',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'pageCatchupButton',
                attributes: {
                    contentId: contentId,
                    source: source
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $lGgRw.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        popupComponent: (0, $ly2zj.CustomPopupContainer),
        shouldFlip: false,
        shouldRenderToParent: true,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
                xcss: $3d9eb45e9938578d$var$ContentWidthStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4RbVT.PageCatchupComponentWithErrorBoundary), {
                contentId: contentId,
                contentType: contentType,
                spaceKey: spaceKey,
                source: source,
                selectedVersions: selectedVersions,
                setIsOpen: setIsOpen,
                contentPath: contentPath
            })),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3gadb.default), {
                hideTooltipOnMouseDown: true,
                position: "bottom",
                content: intl.formatMessage($3d9eb45e9938578d$export$a7357cdd1f0b0168.catchUpButtonText)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                ...triggerProps,
                "aria-haspopup": "dialog",
                onClick: onClick,
                isSelected: isOpen,
                iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ly2zj.AIButtonIcon), {
                        label: ""
                    }),
                "aria-label": intl.formatMessage($3d9eb45e9938578d$export$a7357cdd1f0b0168.catchUpButtonText),
                isDisabled: isDisabled
            }, intl.formatMessage($3d9eb45e9938578d$export$a7357cdd1f0b0168.catchUpButtonText)))
    });
};
module.exports["i18n"] = $3d9eb45e9938578d$export$a7357cdd1f0b0168;
module.exports["PageCatchupPopupComponent"] = $3d9eb45e9938578d$export$93a2b98265b32e4b;

});

parcelRegister("4RbVT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $2Rith = parcelRequire("2Rith");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $9wGTI = parcelRequire("9wGTI");

/* PageCatchupStreamingComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");





var $8C5kA = parcelRequire("8C5kA");


var $xQxzY = parcelRequire("xQxzY");


var $kyKWe = parcelRequire("kyKWe");


var $inPa6 = parcelRequire("inPa6");


var $gdv5Z = parcelRequire("gdv5Z");


var $3j1mV = parcelRequire("3j1mV");


var $fXbFR = parcelRequire("fXbFR");


var $fYQcF = parcelRequire("fYQcF");


var $dOOm2 = parcelRequire("dOOm2");

var $au4KV = parcelRequire("au4KV");

var $8LJEA = parcelRequire("8LJEA");


var $ioNzo = parcelRequire("ioNzo");

var $ar5A7 = parcelRequire("ar5A7");


var $ly2zj = parcelRequire("ly2zj");




const $e3cdf1f83092879d$export$e527c82e5722c1c4 = (streamingInterval = 50, batchSize = 3)=>{
    const [buffer, setBuffer] = (0, $42omo.useState)([]);
    const [inlineLinkingContent, setInlineLinkingContent] = (0, $42omo.useState)('');
    const [lastProcessedLength, setLastProcessedLength] = (0, $42omo.useState)(0);
    const [isBufferStreaming, setIsBufferStreaming] = (0, $42omo.useState)(false);
    const updateBuffer = (0, $42omo.useCallback)((newContent)=>{
        setIsBufferStreaming(true);
        setBuffer((prev)=>[
                ...prev,
                ...newContent.split('')
            ]);
    }, []);
    const resetStreaming = (0, $42omo.useCallback)(()=>{
        setBuffer([]);
        setInlineLinkingContent('');
        setLastProcessedLength(0);
        setIsBufferStreaming(false);
    }, []);
    (0, $42omo.useEffect)(()=>{
        const interval = setInterval(()=>{
            setBuffer((prevBuffer)=>{
                if (prevBuffer.length > 0) {
                    const contentToProcess = prevBuffer.slice(0, batchSize).join('');
                    let updatedBatchSize = batchSize;
                    if (contentToProcess.includes('<')) {
                        let closingBraceCount = 0;
                        let i = 0;
                        for(; i < prevBuffer.length; i++)if (prevBuffer[i] === '>') {
                            if (closingBraceCount === 1) break;
                            closingBraceCount += 1;
                        }
                        updatedBatchSize = i;
                    }
                    setInlineLinkingContent((prevContent)=>prevContent + prevBuffer.slice(0, updatedBatchSize).join(''));
                    return prevBuffer.slice(updatedBatchSize);
                }
                if (isBufferStreaming) setIsBufferStreaming(false);
                return prevBuffer;
            });
        }, streamingInterval);
        return ()=>clearInterval(interval);
    }, [
        batchSize,
        streamingInterval,
        isBufferStreaming
    ]);
    return {
        inlineLinkingContent: inlineLinkingContent,
        buffer: buffer,
        updateBuffer: updateBuffer,
        lastProcessedLength: lastProcessedLength,
        setLastProcessedLength: setLastProcessedLength,
        isBufferStreaming: isBufferStreaming,
        resetStreaming: resetStreaming
    };
};



var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $dPJCf = parcelRequire("dPJCf");


var $6mKj3 = parcelRequire("6mKj3");

const $c393a02d5f46acb0$export$c476676a5dd91e06 = (responseContent)=>{
    if (!responseContent.response || responseContent.response.length === 0 || responseContent.response.length === 1 && Object.keys(responseContent.response[0]).length === 0) return '';
    return responseContent.response.map((item)=>{
        if ('heading' in item && 'changes' in item) {
            const changes = item.changes && item.changes.length > 0 ? item.changes.map((change)=>{
                let formattedChange = '';
                if (change.change) {
                    formattedChange = `* ${change.change}`;
                    if (change.snippet) formattedChange += ` ${change.snippet}`;
                }
                return formattedChange;
            }).filter(Boolean).join('\n') : '';
            return `<h2 style="font-size: var(--ds-font-heading-medium);font-weight: var(--ds-font-weight-medium);">${item.heading}</h2>\n${changes}\n`;
        }
        return '';
    }).join('\n');
};


/* PageCatchupComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $e6pbP = parcelRequire("e6pbP");





var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $6f0Oj = parcelRequire("6f0Oj");

var $bUlM5 = parcelRequire("bUlM5");

var $dcJ7R = parcelRequire("dcJ7R");

var $1GzhS = parcelRequire("1GzhS");

var $ecnYn = parcelRequire("ecnYn");


var $2Pg7f = parcelRequire("2Pg7f");


var $2Nwuj = parcelRequire("2Nwuj");


var $l998X = parcelRequire("l998X");










var $eEA8O = parcelRequire("eEA8O");











var $6fnsQ = parcelRequire("6fnsQ");

const $2c4cc4d659a0f966$var$i18n = (0, $cgtv4.defineMessages)({
    showMore: {
        id: "ai-content-blur.show-more",
        defaultMessage: "Show more"
    }
});
const $2c4cc4d659a0f966$var$BodyStyles = (0, $ecnYn.xcss)({
    overflow: 'hidden',
    position: 'relative'
});
const $2c4cc4d659a0f966$var$BlurStyles = (0, $ecnYn.xcss)({
    position: 'absolute',
    background: `linear-gradient( 0deg, ${`var(--ds-surface-overlay, ${(0, $6fnsQ.N10)})`} 0%, ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"} 100% )`,
    height: '20px',
    width: '100%'
});
const $2c4cc4d659a0f966$export$4a0c9e9f971c9d4 = ({ children: children, onShowMore: onShowMore, shouldOpenInCollapsedView: shouldOpenInCollapsedView, summaryLineHeight: summaryLineHeight, padding: padding })=>{
    const intl = (0, $8C5kA.default)();
    const [isCollapsed, setIsCollapsed] = (0, $42omo.useState)(shouldOpenInCollapsedView);
    const handleShowMoreClick = ()=>{
        if (isCollapsed) {
            setIsCollapsed(false);
            onShowMore?.();
        }
    };
    if (!isCollapsed) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
        testId: "summary-blur-container",
        onClick: handleShowMoreClick,
        style: {
            padding: padding
        },
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $bUlM5.default), {
            alignItems: "end",
            gap: "space.050",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $dcJ7R.default), {
                    grow: "fill",
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $6f0Oj.default), {
                        xcss: $2c4cc4d659a0f966$var$BodyStyles,
                        style: {
                            maxHeight: summaryLineHeight ? `${summaryLineHeight}px` : '40px'
                        },
                        testId: "child-text-box-container",
                        children: [
                            children,
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $6f0Oj.default), {
                                xcss: $2c4cc4d659a0f966$var$BlurStyles,
                                style: {
                                    top: summaryLineHeight ? `${summaryLineHeight - 20}px` : '20px'
                                },
                                testId: "blur-styles-box-container"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
                    appearance: "link",
                    spacing: "none",
                    children: intl.formatMessage($2c4cc4d659a0f966$var$i18n.showMore)
                })
            ]
        })
    }));
};


var $fooTI = parcelRequire("fooTI");










/* PageCatchupFollowUpComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 









var $eyWa4 = parcelRequire("eyWa4");


var $i25hX = parcelRequire("i25hX");


var $ab1fW = parcelRequire("ab1fW");







const $955e1fd2497cca79$export$5153d54fda7ca051 = (0, $cgtv4.defineMessages)({
    pageCatchupUserQuery: {
        id: "page-catchup.follow-up.initial-human-prompt",
        defaultMessage: "Summarize the changes that have happened on this content since my last visit {link}"
    }
});
/**
 * Sanitizes HTML content by removing HTML tags while preserving text content and structure
 * @param htmlContent - The HTML content to sanitize
 * @returns The sanitized text content without HTML tags
 */ const $955e1fd2497cca79$var$sanitizeHtmlContent = (htmlContent)=>{
    // First, let's process the HTML to ensure proper structure
    const processedHtml = htmlContent// Replace heading tags with their text content followed by double newlines to create section breaks
    .replace(/<h[1-6][^>]*>(.*?)<\/h[1-6]>/gi, '\n\n$1\n')// Ensure bullet points start with proper formatting
    .replace(/\* /g, '\n* ')// Handle bullet points that might be at the start of lines
    .replace(/^\s*\*\s/gm, '\n* ');
    // Create a temporary div to extract text content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = processedHtml;
    let textContent = tempDiv.textContent || tempDiv.innerText || '';
    // Clean up the text content
    textContent = textContent.replace(/\n\s*\n\s*\n/g, '\n\n') // Replace multiple line breaks with double line breaks for section separation
    .replace(/[ \t]+/g, ' ') // Replace multiple spaces/tabs with single space (but preserve line breaks)
    .trim(); // Remove leading/trailing whitespace
    // Remove all instances of [number] since we don't have inline linking in chat yet
    textContent = textContent.replace(/ ?\[[0-9]+\]/g, '');
    return textContent;
};
const $955e1fd2497cca79$var$contentPathToLink = (contentPath)=>{
    return `${window.location.origin}${contentPath}`;
};
const $955e1fd2497cca79$export$19fc7a97b20ab78e = (contentPath, content, formatMessage)=>{
    const sanitizedContent = $955e1fd2497cca79$var$sanitizeHtmlContent(content);
    const contentLink = $955e1fd2497cca79$var$contentPathToLink(contentPath);
    return [
        {
            human_message: {
                content: formatMessage($955e1fd2497cca79$export$5153d54fda7ca051.pageCatchupUserQuery, {
                    link: contentLink
                })
            },
            agent_message: {
                content: sanitizedContent
            }
        }
    ];
};


// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $22677384a1f01983$var$FollowUpButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_anlp1o7k _bepv4jcg _14hp1osq",
            __cmplp.className
        ])
    });
});
const $22677384a1f01983$export$2b864936d8effc3f = ({ followUpContent: followUpContent, pageCatchupContent: pageCatchupContent, contentPath: contentPath, setIsOpen: setIsOpen })=>{
    const publish = (0, $i25hX.usePublish)('ai-mate');
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const { trackAIResultAction: trackAIResultAction } = (0, $fYQcF.useAIEventsInstrumentation)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, followUpContent.map((followUp, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($22677384a1f01983$var$FollowUpButtonWrapper, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ab1fW.FollowUpButton), {
            key: followUp.text,
            followUpIndex: index,
            followUpText: followUp.text,
            followUpType: followUp.type,
            experienceId: "page-catchup",
            onClick: ()=>{
                trackAIResultAction('followUpQuestionClick');
                publish({
                    type: 'chat-new',
                    source: 'page-catchup',
                    data: {
                        name: followUp.text.substring(0, 30),
                        dialogues: (0, $955e1fd2497cca79$export$19fc7a97b20ab78e)(contentPath, pageCatchupContent, formatMessage),
                        prompt: followUp.text
                    }
                });
                setIsOpen(false);
            }
        }))));
};


const $dd9384d47412f91f$export$8546c1cce0fb8fe2 = ({ isPageCatchupFollowUpEnabled: isPageCatchupFollowUpEnabled, followUpContent: followUpContent, content: content, contentPath: contentPath, setIsOpen: setIsOpen })=>{
    if (!isPageCatchupFollowUpEnabled) return null;
    if (!followUpContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $22677384a1f01983$export$2b864936d8effc3f), {
        followUpContent: followUpContent,
        pageCatchupContent: content,
        contentPath: contentPath,
        setIsOpen: setIsOpen
    });
};


/* NewContentHistoryContributorsAndHeader.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $1s5hv = parcelRequire("1s5hv");



var $iXCQx = parcelRequire("iXCQx");


var $bqnQm = parcelRequire("bqnQm");

const $454b0bc541745812$var$i18n = (0, $cgtv4.defineMessages)({
    editorsCount: {
        id: "page-catchup.new-content-history-header.editors.count",
        defaultMessage: "{count, plural, one {1 person} other {{count} people}} edited these versions"
    }
});
const $454b0bc541745812$var$styles = {
    wrapper: "_2rko12b0 _1yt4pxbi _1h6dmuej _189ee4h9 _1dqonqa1 _bfhksm61",
    textWrapper: "_otyru2gc"
};
const $454b0bc541745812$export$69bf361089858925 = ({ editors: editors })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        xcss: $454b0bc541745812$var$styles.wrapper,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: $454b0bc541745812$var$styles.textWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
        color: "color.text.subtle",
        weight: "bold"
    }, intl.formatMessage($454b0bc541745812$var$i18n.editorsCount, {
        count: editors.length
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bqnQm.ContributorsOverflow), {
        contributors: editors,
        shouldUseGridStyles: true
    }));
};















const $f609a69515d1e116$var$i18n = (0, $cgtv4.defineMessages)({
    editorsNameListText: {
        id: "page-catchup.editors.name.list.text",
        defaultMessage: "{editorsCount, plural, one {{firstEditor} has} =2 {{firstEditor} and {secondEditor} have} =3 {{firstEditor}, {secondEditor}, and {thirdEditor} have} other {{firstEditor}, {secondEditor}, {thirdEditor} and {remainingEditorCount} others have}} edited this content"
    },
    editorsNameListTextNoVerbiage: {
        id: "page-catchup.editors.name.list.text.no.verbiage",
        defaultMessage: "{editorsCount, plural, one {{firstEditor}} =2 {{firstEditor} and {secondEditor}} =3 {{firstEditor}, {secondEditor}, and {thirdEditor}} other {{firstEditor}, {secondEditor}, {thirdEditor} and {remainingEditorCount} others}}"
    }
});
const $f609a69515d1e116$export$d86d70bd36fbdafc = ({ editors: editors, showNoVerbiage: showNoVerbiage })=>{
    const editorsCount = editors.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "editors-name-list",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        xcss: (0, $ecnYn.xcss)({
            font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...showNoVerbiage ? $f609a69515d1e116$var$i18n.editorsNameListTextNoVerbiage : $f609a69515d1e116$var$i18n.editorsNameListText,
        values: {
            editorsCount: editorsCount,
            firstEditor: editorsCount > 0 ? editors[0].name : null,
            secondEditor: editorsCount > 1 ? editors[1].name : null,
            thirdEditor: editorsCount > 2 ? editors[2].name : null,
            remainingEditorCount: editorsCount - 3
        }
    }));
};




















var $63blV = parcelRequire("63blV");




const $06ee68beb9b6b369$var$footerBoxStyles = (0, $ecnYn.xcss)({
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #091E4224)"}`
});
const $06ee68beb9b6b369$var$boxTextStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest'
});
const $06ee68beb9b6b369$var$newContentHistoryBoxTextStyles = (0, $ecnYn.xcss)({
    marginTop: 'space.800',
    textAlign: 'center'
});
const $06ee68beb9b6b369$var$newContentHistoryStackStyles = (0, $ecnYn.xcss)({
    height: '100%',
    justifyContent: 'space-between'
});
const $06ee68beb9b6b369$var$i18n = (0, $cgtv4.defineMessages)({
    diffEmptyBetweenVersionsText: {
        id: "page-catchup.diff.empty.between.versions.text",
        defaultMessage: "These versions are too similar for Atlassian Intelligence (AI) to generate a summary of the differences between them."
    }
});
const $06ee68beb9b6b369$export$2f0d20c33235025e = ({ isInNewContentHistory: isInNewContentHistory, contentId: contentId })=>{
    const intl = (0, $8C5kA.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: isInNewContentHistory ? $06ee68beb9b6b369$var$newContentHistoryStackStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: "space.250",
        xcss: [
            $06ee68beb9b6b369$var$boxTextStyles,
            isInNewContentHistory && $06ee68beb9b6b369$var$newContentHistoryBoxTextStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $06ee68beb9b6b369$var$i18n.diffEmptyBetweenVersionsText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        testId: "ai-attribution-footer",
        paddingInline: "space.200",
        paddingBlock: "space.050",
        xcss: !isInNewContentHistory ? $06ee68beb9b6b369$var$footerBoxStyles : undefined
    }, isInNewContentHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ly2zj.NewContentHistoryAISummaryFooter), {
        analyticsProperties: {
            source: 'pageCatchup'
        },
        contentId: contentId,
        summaryText: intl.formatMessage($06ee68beb9b6b369$var$i18n.diffEmptyBetweenVersionsText),
        showBorder: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $63blV.AIAttributionFooter), null)));
};


const $b47380d9a1361e15$var$ScrollableBody = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isInNewContentHistory: isInNewContentHistory, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11c81ixg _18m91wug _1suq1j28 _1ke81kwk _155a1mok _aaynm7j4 _1ogl15ej",
            __cmplp.isInNewContentHistory && "_n3td1jfw",
            __cmplp.className
        ])
    });
});
const $b47380d9a1361e15$var$HeaderStyles = (0, $ecnYn.xcss)({
    backgroundColor: 'color.background.accent.gray.subtlest',
    borderRadius: 'radius.small',
    padding: 'space.100'
});
const $b47380d9a1361e15$var$StackStyles = (0, $ecnYn.xcss)({
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    height: '100%'
});
const $b47380d9a1361e15$var$ContentStyles = (0, $ecnYn.xcss)({
    gap: 'space.200',
    height: '100%'
});
const $b47380d9a1361e15$var$ContentHeightStyles = (0, $ecnYn.xcss)({
    maxHeight: '350px'
});
const $b47380d9a1361e15$var$FooterObjectSidebarStyles = (0, $ecnYn.xcss)({
    // Object sidebar padding is 16px, this ensures that the footer isn't cutoff by parent padding
    width: 'calc(100% + 32px)',
    marginLeft: 'space.negative.200'
});
const $b47380d9a1361e15$var$i18n = (0, $cgtv4.defineMessages)({
    lastVisitedOn: {
        id: "page-catchup.last-visited-on-text",
        defaultMessage: "Changes since you last visited on {lastVisitedOnDate}."
    },
    firstTimeVisit: {
        id: "page-catchup.first-time-visit-text",
        defaultMessage: "Since this is your first time visiting this content, you\u2019re seeing a page summary instead of a summary of changes."
    },
    noChangesSinceLastVisit: {
        id: "page-catchup.no-changes-since-last-visit-text",
        defaultMessage: "There haven\u2019t been any changes since your last visit on {lastVisitedOnDate}. We\u2019ve generated this summary instead to help refresh your memory."
    },
    fullVersionHistoryLinkText: {
        id: "page-catchup.full.version.history.link.text",
        defaultMessage: "See changes in version history"
    },
    changesBetweenVersionsText: {
        id: "page-catchup.changes.between.versions.text",
        defaultMessage: "Changes between selected versions"
    },
    changesWithinTimeframeHoursText: {
        id: "page-catchup.changes.within.timeframe.hours.text",
        defaultMessage: "Changes within the last {numHours} hours."
    },
    noChangesWithinTimeframeHoursText: {
        id: "page-catchup.no.changes.within.timeframe.hours.text",
        defaultMessage: "There haven\u2019t been any changes within the last {numHours} hours. We\u2019ve generated this summary instead to help refresh your memory."
    },
    changesWithinTimeframeDaysText: {
        id: "page-catchup.changes.within.timeframe.days.text",
        defaultMessage: "Changes within the last {numDays} days."
    },
    noChangesWithinTimeframeDaysText: {
        id: "page-catchup.no.changes.within.timeframe.days.text",
        defaultMessage: "There haven\u2019t been any changes within the last {numDays} days. We\u2019ve generated this summary instead to help refresh your memory."
    },
    allTimeChangesText: {
        id: "page-catchup.all.time.changes.text",
        defaultMessage: "All time changes."
    },
    noChangesAllTimeText: {
        id: "page-catchup.no.changes.all.time.text",
        defaultMessage: "There haven\u2019t been any changes. We\u2019ve generated this summary instead to help refresh your memory."
    }
});
const $b47380d9a1361e15$export$c463287b61deee24 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ contentId: contentId, content: content, contentType: contentType, spaceKey: spaceKey, lastVisitedOnDate: lastVisitedOnDate, editors: editors, hideMetadata: hideMetadata, versionHistoryLink: versionHistoryLink, onVersionHistoryLinkClick: onVersionHistoryLinkClick, hasVersionChangedSinceLastVisit: hasVersionChangedSinceLastVisit, onShowMoreClick: onShowMoreClick, source: source, isVersionDiffEmpty: isVersionDiffEmpty, isInObjectSidebar: isInObjectSidebar, isInNewContentHistory: isInNewContentHistory, updateType: updateType, timeframeLength: timeframeLength, followUpContent: followUpContent, isRovoEnabled: isRovoEnabled, setIsOpen: setIsOpen, contentPath: contentPath, showAIDisclaimer: showAIDisclaimer = true }, catchUpContentRef)=>{
    const getHeaderText = ()=>{
        if (updateType === 'BETWEEN_VERSIONS' && source === 'pageHistory' && !isVersionDiffEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b47380d9a1361e15$var$i18n.changesBetweenVersionsText);
        if (updateType === 'SINCE_X_DAYS' && timeframeLength) switch(timeframeLength){
            case 'ALL_TIME':
                const allTimeKey = hasVersionChangedSinceLastVisit ? 'allTimeChangesText' : 'noChangesAllTimeText';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b47380d9a1361e15$var$i18n[allTimeKey]);
            case 'ONE_DAY_AGO':
                const dayKey = hasVersionChangedSinceLastVisit ? 'changesWithinTimeframeHoursText' : 'noChangesWithinTimeframeHoursText';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$b47380d9a1361e15$var$i18n[dayKey],
                    values: {
                        numHours: 24
                    }
                });
            case 'ONE_WEEK_AGO':
                const weekKey = hasVersionChangedSinceLastVisit ? 'changesWithinTimeframeDaysText' : 'noChangesWithinTimeframeDaysText';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$b47380d9a1361e15$var$i18n[weekKey],
                    values: {
                        numDays: 7
                    }
                });
            case 'TWO_WEEKS_AGO':
                const twoWeekKey = hasVersionChangedSinceLastVisit ? 'changesWithinTimeframeDaysText' : 'noChangesWithinTimeframeDaysText';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$b47380d9a1361e15$var$i18n[twoWeekKey],
                    values: {
                        numDays: 14
                    }
                });
            case 'ONE_MONTH_AGO':
                const monthKey = hasVersionChangedSinceLastVisit ? 'changesWithinTimeframeDaysText' : 'noChangesWithinTimeframeDaysText';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                    ...$b47380d9a1361e15$var$i18n[monthKey],
                    values: {
                        numDays: 30
                    }
                });
        }
        if (updateType === 'SINCE_LAST_VIEWED_MARKDOWN') {
            if (!lastVisitedOnDate) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b47380d9a1361e15$var$i18n.firstTimeVisit);
            const messageKey = hasVersionChangedSinceLastVisit ? 'lastVisitedOn' : 'noChangesSinceLastVisit';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
                ...$b47380d9a1361e15$var$i18n[messageKey],
                values: {
                    lastVisitedOnDate: lastVisitedOnDate
                }
            });
        }
    };
    if (source === 'pageHistory' && isVersionDiffEmpty) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ly2zj.FeedbackCollectorPropertiesProvider), {
        entrypointId: "d4c9238b-d3d6-4298-83d9-10f6bddd4f2b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $06ee68beb9b6b369$export$2f0d20c33235025e), {
        isInNewContentHistory: isInNewContentHistory,
        contentId: contentId
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ly2zj.FeedbackCollectorPropertiesProvider), {
        entrypointId: "d4c9238b-d3d6-4298-83d9-10f6bddd4f2b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b47380d9a1361e15$var$StackStyles,
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        padding: isInObjectSidebar ? 'space.100' : 'space.200'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        space: "space.200"
    }, isInNewContentHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $454b0bc541745812$export$69bf361089858925), {
        editors: editors
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1GzhS.default), {
        xcss: $b47380d9a1361e15$var$HeaderStyles,
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), null, getHeaderText()), (lastVisitedOnDate && hasVersionChangedSinceLastVisit || source === 'pageHistory') && editors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Pg7f.default), {
        size: "small",
        data: editors,
        testId: "page-catchup",
        maxCount: 4
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $f609a69515d1e116$export$d86d70bd36fbdafc), {
        editors: editors
    }))), (source !== 'pageHistory' || !isVersionDiffEmpty) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bUlM5.default), {
        direction: "column",
        xcss: [
            $b47380d9a1361e15$var$ContentStyles,
            !isInObjectSidebar && !isInNewContentHistory && $b47380d9a1361e15$var$ContentHeightStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2c4cc4d659a0f966$export$4a0c9e9f971c9d4), {
        shouldOpenInCollapsedView: (!lastVisitedOnDate || !hasVersionChangedSinceLastVisit) && source !== 'pageHistory' && !isInObjectSidebar,
        onShowMore: onShowMoreClick,
        summaryLineHeight: 80
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($b47380d9a1361e15$var$ScrollableBody, {
        ref: catchUpContentRef,
        isInNewContentHistory: isInNewContentHistory,
        "data-testid": "scrollable-body"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fooTI.AITelepointerWrapper), {
        hideTelepointer: !hideMetadata
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6pbP.default), null, content))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dd9384d47412f91f$export$8546c1cce0fb8fe2), {
        content: content,
        contentPath: contentPath,
        setIsOpen: setIsOpen,
        isPageCatchupFollowUpEnabled: !isInNewContentHistory && isRovoEnabled && (0, $9wGTI.fg)('page-catchup-follow-up-enabled'),
        followUpContent: followUpContent
    }))), versionHistoryLink && !hideMetadata && hasVersionChangedSinceLastVisit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Nwuj.default), {
        href: versionHistoryLink,
        onClick: onVersionHistoryLinkClick,
        target: "_blank"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $b47380d9a1361e15$var$i18n.fullVersionHistoryLinkText)))), !hideMetadata && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
        xcss: isInObjectSidebar && $b47380d9a1361e15$var$FooterObjectSidebarStyles
    }, isInNewContentHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ly2zj.NewContentHistoryAISummaryFooter), {
        analyticsProperties: {
            source: 'pageCatchup'
        },
        contentId: contentId,
        summaryText: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ly2zj.AISummaryFooter), {
        analyticsProperties: {
            source: 'pageCatchup'
        },
        contentId: contentId,
        spaceKey: spaceKey,
        contentType: contentType,
        summaryText: content,
        showAIDisclaimer: showAIDisclaimer
    }))));
});


/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $551036f28c08b5b8$export$fe6033382a69eea9 = /*#__PURE__*/ function(CatchupContentType) {
    CatchupContentType["BLOGPOST"] = "BLOGPOST";
    CatchupContentType["PAGE"] = "PAGE";
    return CatchupContentType;
}({});


function $676d15788c30fd82$export$2364cf53dded03dd(editors) {
    return editors.map((u)=>{
        return {
            name: u?.displayName ?? '',
            src: u && 'profilePicture' in u ? u?.profilePicture?.path : ''
        };
    });
}


function $b00440823166005e$export$757dbcc1bd42832(ISOdate, locale) {
    if (!ISOdate) return;
    const dateOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    };
    return new Date(ISOdate).toLocaleDateString(locale, dateOptions);
}



var $lSOAM = parcelRequire("lSOAM");


var $jIOyV = parcelRequire("jIOyV");

const $f249c720b72bd2f9$export$42c905138efbcdac = (0, $lSOAM.createInteractionMetric)({
    key: (0, $jIOyV.AI_CONTENT_CATCHUP_INTERACTION)
});






var $1NBp8 = parcelRequire("1NBp8");

var $jlIaF = parcelRequire("jlIaF");

const $dbb424c9806aaca2$var$usePrevVersionParam = (0, $dPJCf.createSingleQueryParamHook)('prevVersion');
const $dbb424c9806aaca2$var$useCurrentVersionParam = (0, $dPJCf.createSingleQueryParamHook)('currVersion');
const $dbb424c9806aaca2$export$3042bbbffe78f13c = (contentId, spaceKey, pageVersion)=>{
    const fallbackLink = (0, $1NBp8.CONTENT_HISTORY).toUrl({
        spaceKey: spaceKey,
        contentId: contentId
    });
    const prevVersionFromParam = parseInt($dbb424c9806aaca2$var$usePrevVersionParam() ?? '');
    const currVersionFromParam = parseInt($dbb424c9806aaca2$var$useCurrentVersionParam() ?? '');
    if (pageVersion < 0 && (isNaN(currVersionFromParam) || isNaN(prevVersionFromParam))) return {
        versionHistoryLink: fallbackLink
    };
    const currVersion = isNaN(currVersionFromParam) ? pageVersion : currVersionFromParam;
    const prevVersion = isNaN(prevVersionFromParam) ? pageVersion - 1 : prevVersionFromParam;
    const versionDiffLink = `${(0, $jlIaF.CONTEXT_PATH)}/pages/diffpagesbyversion.action?pageId=${contentId}&selectedPageVersions=${prevVersion}&selectedPageVersions=${currVersion}`;
    return {
        versionHistoryLink: versionDiffLink
    };
};


const $68e47fc55df08327$var$PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery = (0, $eSUdr.default)`query PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery($contentId:ID!$contentType:CatchupContentType!$endTimeMs:Long!$updateType:CatchupOverviewUpdateType!){catchupEditMetadataForContent(contentId:$contentId contentType:$contentType endTimeMs:$endTimeMs updateType:$updateType){lastVisitTimeISO hasVersionChangedSinceLastVisit users{displayName profilePicture{path}}}content(id:$contentId){nodes{version{number}}}}`;
const $68e47fc55df08327$var$PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery = (0, $eSUdr.default)`query PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery($contentId:ID!$contentType:CatchupContentType!$originalContentVersion:Int!$revisedContentVersion:Int!){catchupVersionDiffMetadataForContent(contentId:$contentId contentType:$contentType originalContentVersion:$originalContentVersion revisedContentVersion:$revisedContentVersion){isDiffEmpty users{displayName profilePicture{height isDefault width path}}}}`;
const $68e47fc55df08327$var$useOpenContentCatchupParam = (0, $dPJCf.createSingleQueryParamHook)('openContentCatchup'); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/design-system/use-tokens-typography
const $68e47fc55df08327$var$styles = null;
const $68e47fc55df08327$export$4c578b92894b49da = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, selectedVersions: selectedVersions, isInObjectSidebar: isInObjectSidebar, isInNewContentHistory: isInNewContentHistory, setIsOpen: setIsOpen, contentPath: contentPath, showAIDisclaimer: showAIDisclaimer = true })=>{
    const { locale: locale } = (0, $8C5kA.default)();
    const { isRovoEnabled: isRovoEnabled, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, contentId, contentType);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [aiInteractionId] = (0, $42omo.useState)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const catchUpContentRef = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(catchUpContentRef);
    const [dateInMs] = (0, $42omo.useState)(Date.now());
    const [hideMetadata, setHideMetadata] = (0, $42omo.useState)(true);
    const { inlineLinkingContent: inlineLinkingContent, updateBuffer: updateBuffer, lastProcessedLength: lastProcessedLength, setLastProcessedLength: setLastProcessedLength, isBufferStreaming: isBufferStreaming } = (0, $e3cdf1f83092879d$export$e527c82e5722c1c4)();
    const analyticsProperties = {
        source: 'pageCatchup',
        additionalAnalyticsAttributes: {
            subSource: source
        }
    };
    const originalContentVersion = selectedVersions ? Math.min(...Array.from(selectedVersions)) : 0;
    const revisedContentVersion = selectedVersions ? Math.max(...Array.from(selectedVersions)) : 0;
    const hasSelectedVersions = selectedVersions && selectedVersions.size > 1 && source === 'pageHistory';
    const isStreamingDone = (0, $42omo.useRef)(false);
    const isStreamInitializationDone = (0, $42omo.useRef)(false);
    const timeToFirstAnswerPart = (0, $42omo.useRef)(0);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIResultAction: trackAIResultAction, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const hasQueryParamOpenSet = $68e47fc55df08327$var$useOpenContentCatchupParam() === 'true';
    const contentTypeEnum = contentType === 'page' ? (0, $551036f28c08b5b8$export$fe6033382a69eea9).PAGE : (0, $551036f28c08b5b8$export$fe6033382a69eea9).BLOGPOST;
    let agentNamedId = 'content_catchup_agent';
    let updateType = 'SINCE_LAST_VIEWED_MARKDOWN';
    if (hasSelectedVersions) {
        agentNamedId = 'content_catchup_version_diff_agent';
        updateType = 'BETWEEN_VERSIONS';
    } else if ((0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream')) {
        agentNamedId = 'content_catchup_streaming_inline_linking_agent';
        updateType = 'SINCE_LAST_VIEWED_MARKDOWN';
    }
    const { data: data, error: defaultMetaDataError } = (0, $xQxzY.useQuery)($68e47fc55df08327$var$PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            endTimeMs: dateInMs,
            updateType: updateType
        },
        skip: hasSelectedVersions
    });
    const { data: versionDiffMetadata, error: versionDiffMetadataError } = (0, $xQxzY.useQuery)($68e47fc55df08327$var$PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            originalContentVersion: originalContentVersion,
            revisedContentVersion: revisedContentVersion
        },
        skip: !hasSelectedVersions
    });
    const metaDataError = defaultMetaDataError || versionDiffMetadataError;
    const isVersionDiffEmpty = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.isDiffEmpty ?? false;
    const versionDiffUsers = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.users ?? [];
    const versionDiffEditors = (0, $676d15788c30fd82$export$2364cf53dded03dd)(versionDiffUsers);
    const setIsStreamingDone = ()=>{
        isStreamingDone.current = true;
    };
    const setIsStreamInitializationDone = ()=>{
        isStreamInitializationDone.current = true;
    };
    const onShowMoreClick = (0, $42omo.useCallback)(()=>{
        trackAIResultAction('showMoreClicked');
    }, [
        trackAIResultAction
    ]);
    const request = (0, $42omo.useMemo)(()=>({
            recipient_agent_named_id: agentNamedId,
            agent_input_context: {
                content_ari: pageAri ?? '',
                locale: locale,
                end_time_ms: dateInMs,
                update_type: updateType,
                ...hasSelectedVersions && {
                    original_content_version: Math.min(...Array.from(selectedVersions)),
                    revised_content_version: Math.max(...Array.from(selectedVersions))
                }
            }
        }), [
        agentNamedId,
        pageAri,
        locale,
        dateInMs,
        updateType,
        hasSelectedVersions,
        selectedVersions
    ]);
    const onStateChange = (0, $42omo.useCallback)((state)=>{
        switch(state.responseState){
            case (0, $ioNzo.AIAgentResponseState).Initialization:
                if (state.content === null) {
                    experienceTracker.start({
                        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                    });
                    (0, $f249c720b72bd2f9$export$42c905138efbcdac).start();
                    trackAIInteractionInit();
                    timeToFirstAnswerPart.current = Date.now();
                }
                break;
            case (0, $ioNzo.AIAgentResponseState).Error:
                const { status_code: status_code, message_template: message_template } = state.error.message;
                (0, $f249c720b72bd2f9$export$42c905138efbcdac).stop();
                trackAIResultError({
                    aiErrorCode: status_code,
                    aiErrorMessage: message_template
                });
                setIsStreamingDone();
                break;
            case (0, $ioNzo.AIAgentResponseState).AnswerPart:
                if (!isStreamInitializationDone.current) {
                    setIsStreamInitializationDone();
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'streamReceived',
                            actionSubject: 'pageCatchup',
                            source: source ?? 'page',
                            actionSubjectId: 'pageCatchupDialog',
                            attributes: {
                                contentId: contentId,
                                timeToFirstAnswerPartInMs: Date.now() - timeToFirstAnswerPart.current,
                                agentNamedId: agentNamedId
                            }
                        }
                    }).fire();
                }
                const fullContent = (0, $c393a02d5f46acb0$export$c476676a5dd91e06)(state.content);
                const newContent = fullContent.slice(lastProcessedLength);
                updateBuffer(newContent);
                setLastProcessedLength(fullContent.length);
                break;
            case (0, $ioNzo.AIAgentResponseState).FinalResponse:
                (0, $f249c720b72bd2f9$export$42c905138efbcdac).stop();
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'pageCatchupDialog',
                        attributes: {
                            contentId: contentId,
                            aiInteractionId: aiInteractionId,
                            hasQueryParamOpenSet: hasQueryParamOpenSet
                        }
                    }
                }).fire();
                trackAIResultView();
                setIsStreamingDone();
                break;
            default:
                break;
        }
    }, [
        trackAIResultError,
        lastProcessedLength,
        updateBuffer,
        setLastProcessedLength,
        createAnalyticsEvent,
        contentId,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultView,
        experienceTracker,
        trackAIInteractionInit,
        agentNamedId,
        source
    ]);
    const [{ content: content, responseState: responseState, error: streamSummaryError }] = (0, $ar5A7.useAIAgentStreaming)(request, {
        enablePartialJson: (0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream'),
        delayChunkUpdate: {
            gap: 10,
            time: 20
        },
        headers: {
            'x-experience-id': 'content-catchup',
            'x-product': 'confluence'
        }
    }, onStateChange);
    (0, $42omo.useEffect)(()=>{
        if (responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse) {
            if (hideMetadata && !isBufferStreaming) setHideMetadata(false);
            if (source !== 'pageHistory') (0, $6mKj3.manuallyLogExpExposure)('cc_ai_consumption_pc_streaming_inline_linking');
        }
    }, [
        responseState,
        source,
        hideMetadata,
        isBufferStreaming
    ]);
    const handleContainerClick = (0, $42omo.useCallback)((e)=>{
        const target = e.target;
        const linkElement = target.closest('a[id="#page-catchup-text-fragment"]');
        if (linkElement) trackAIResultAction('inlineLinkClicked');
    }, [
        trackAIResultAction
    ]);
    (0, $42omo.useEffect)(()=>{
        if (responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse && !isBufferStreaming && (0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream')) {
            const container = document.querySelector('div[data-testid="ai-border-container"]');
            const panel = document.querySelector('div[data-testid="object-sidebar-panel"]');
            if (container) {
                container.addEventListener('click', handleContainerClick);
                return ()=>{
                    container.removeEventListener('click', handleContainerClick);
                };
            } else if (panel) {
                panel.addEventListener('click', handleContainerClick);
                return ()=>{
                    panel.removeEventListener('click', handleContainerClick);
                };
            }
        }
    }, [
        responseState,
        handleContainerClick,
        isBufferStreaming
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'pageCatchup',
                    source: source ?? 'page',
                    actionSubjectId: 'pageCatchupDialog',
                    attributes: {
                        contentId: contentId,
                        dwellTime: getDwellTime(),
                        aiInteractionId: aiInteractionId,
                        hasQueryParamOpenSet: hasQueryParamOpenSet
                    }
                }
            }).fire();
            if (!isStreamInitializationDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'stream_initialization'
                }
            });
            else if (!isStreamingDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'answer_part_streaming'
                }
            });
        }; // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const lastVisitedOnDate = (0, $b00440823166005e$export$757dbcc1bd42832)(data?.catchupEditMetadataForContent?.lastVisitTimeISO, locale);
    const hasVersionChangedSinceLastVisit = data?.catchupEditMetadataForContent?.hasVersionChangedSinceLastVisit ?? false;
    const users = data?.catchupEditMetadataForContent?.users ?? [];
    const defaultEditors = (0, $676d15788c30fd82$export$2364cf53dded03dd)(users);
    const editors = source === 'pageHistory' ? versionDiffEditors : defaultEditors;
    const pageVersion = data?.content?.nodes?.[0]?.version?.number ?? -1;
    const { versionHistoryLink: versionHistoryLink } = (0, $dbb424c9806aaca2$export$3042bbbffe78f13c)(contentId, spaceKey, pageVersion);
    const onVersionHistoryLinkClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'pageCatchup',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'pageCatchupVersionHistoryLink',
                attributes: {
                    contentId: contentId,
                    aiInteractionId: aiInteractionId,
                    hasQueryParamOpenSet: hasQueryParamOpenSet
                }
            }
        }).fire();
        trackAIResultAction('versionHistoryLinkClick');
    }, [
        contentId,
        createAnalyticsEvent,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultAction
    ]);
    const pageCatchupComponentProps = {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        lastVisitedOnDate: lastVisitedOnDate,
        editors: editors,
        ref: catchUpContentRef,
        hideMetadata: hideMetadata,
        versionHistoryLink: versionHistoryLink,
        onVersionHistoryLinkClick: onVersionHistoryLinkClick,
        hasVersionChangedSinceLastVisit: hasVersionChangedSinceLastVisit,
        onShowMoreClick: onShowMoreClick,
        source: source,
        isVersionDiffEmpty: isVersionDiffEmpty,
        isInObjectSidebar: isInObjectSidebar,
        isInNewContentHistory: isInNewContentHistory,
        updateType: updateType,
        formattedTimeframeLength: undefined,
        isRovoEnabled: isRovoEnabled,
        setIsOpen: setIsOpen,
        contentPath: contentPath
    };
    const renderPageCatchupComponent = (contentToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b47380d9a1361e15$export$c463287b61deee24), {
            ...pageCatchupComponentProps,
            content: contentToRender,
            showAIDisclaimer: showAIDisclaimer
        });
    const renderContent = ()=>{
        const isInInlineLinkingExperiment = source !== 'pageHistory' && (0, $6mKj3.expValEqualsNoExposure)('cc_ai_consumption_pc_streaming_inline_linking', 'cohort', 'inline_linking_stream');
        switch(responseState){
            case (0, $ioNzo.AIAgentResponseState).Initialization:
                return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                    paddingInline: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8LJEA.AISummaryLoading), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $au4KV.AIStreamLoading), null);
            case (0, $ioNzo.AIAgentResponseState).Error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ly2zj.SmartsSummaryErrorComponent), {
                    analyticsProperties: analyticsProperties,
                    errorFromApolloOrStream: streamSummaryError,
                    contentId: contentId,
                    experienceName: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                });
            case (0, $ioNzo.AIAgentResponseState).AnswerPart:
            case (0, $ioNzo.AIAgentResponseState).FinalResponse:
                if (isInInlineLinkingExperiment) return renderPageCatchupComponent(inlineLinkingContent);
                return renderPageCatchupComponent(content);
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_ggmhs13h"
        ])
    }, isInObjectSidebar || isInNewContentHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dOOm2.AIBorder), {
        loading: responseState === (0, $ioNzo.AIAgentResponseState).Initialization
    }, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $ioNzo.AIAgentResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })));
};


/* PageCatchupWrapperComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 








































var $kAaxz = parcelRequire("kAaxz");

var $d3UlG = parcelRequire("d3UlG");


var $2YmgJ = parcelRequire("2YmgJ");
































const $9ed1632df7d8fede$export$60847e9d6d4c2441 = ({ contentAri: contentAri, locale: locale, updateType: updateType, endTimeMs: endTimeMs, timeframeLength: timeframeLength, selectedVersions: selectedVersions, enablePartialJson: enablePartialJson = false, enableFollowUp: enableFollowUp = false })=>{
    const originalContentVersion = selectedVersions ? Math.min(...Array.from(selectedVersions)) : 0;
    const revisedContentVersion = selectedVersions ? Math.max(...Array.from(selectedVersions)) : 1;
    return [
        {
            ai_feature_input: {
                content_ari: contentAri,
                locale: locale,
                update_type: updateType,
                end_time_ms: endTimeMs,
                timeframe_length: timeframeLength,
                original_content_version: originalContentVersion,
                revised_content_version: revisedContentVersion
            }
        },
        {
            apiPath: 'v2/ai-feature/confluence-content-catchup',
            delayChunkUpdate: {
                gap: 10,
                time: 20
            },
            enablePartialJson: enablePartialJson,
            enableFollowUp: enableFollowUp,
            headers: {
                'x-experience-id': selectedVersions ? 'catchup-version-summary' : 'content-catchup',
                'x-product': 'confluence'
            }
        }
    ];
};



var $16tNb = parcelRequire("16tNb");


const $5811907f4df745b5$var$PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery = (0, $eSUdr.default)`query PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery($contentId:ID!$contentType:CatchupContentType!$endTimeMs:Long!$updateType:CatchupOverviewUpdateType!){catchupEditMetadataForContent(contentId:$contentId contentType:$contentType endTimeMs:$endTimeMs updateType:$updateType){lastVisitTimeISO hasVersionChangedSinceLastVisit users{displayName profilePicture{path}}}content(id:$contentId){nodes{version{number}}}}`;
const $5811907f4df745b5$var$PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery = (0, $eSUdr.default)`query PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery($contentId:ID!$contentType:CatchupContentType!$originalContentVersion:Int!$revisedContentVersion:Int!){catchupVersionDiffMetadataForContent(contentId:$contentId contentType:$contentType originalContentVersion:$originalContentVersion revisedContentVersion:$revisedContentVersion){isDiffEmpty users{displayName profilePicture{height isDefault width path}}}}`;
const $5811907f4df745b5$var$useOpenContentCatchupParam = (0, $dPJCf.createSingleQueryParamHook)('openContentCatchup');
const $5811907f4df745b5$var$styles = null;
const $5811907f4df745b5$export$f663be73c38b26f1 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, selectedVersions: selectedVersions, isInObjectSidebar: isInObjectSidebar, isInNewContentHistory: isInNewContentHistory, setIsOpen: setIsOpen, contentPath: contentPath, showAIDisclaimer: showAIDisclaimer = true, allowCustomFollowUp: allowCustomFollowUp = false })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8C5kA.default)();
    const { isRovoEnabled: isRovoEnabled, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { pageAri: pageAri } = (0, $3j1mV.useConfluencePageAri)(cloudId, contentId, contentType);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [aiInteractionId] = (0, $42omo.useState)((0, (/*@__PURE__*/$parcel$interopDefault($kyKWe)))());
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const catchUpContentRef = (0, $42omo.useRef)(null);
    const { getDwellTime: getDwellTime } = (0, $fXbFR.usePopupDwellTime)(catchUpContentRef);
    const [dateInMs] = (0, $42omo.useState)(Date.now());
    const [hideMetadata, setHideMetadata] = (0, $42omo.useState)(true);
    const currentAnswerChunk = (0, $42omo.useRef)(0);
    const { inlineLinkingContent: inlineLinkingContent, buffer: buffer, updateBuffer: updateBuffer, lastProcessedLength: lastProcessedLength, setLastProcessedLength: setLastProcessedLength, isBufferStreaming: isBufferStreaming, resetStreaming: resetStreaming } = (0, $e3cdf1f83092879d$export$e527c82e5722c1c4)(35, 3);
    const [filterState] = (0, $16tNb.usePageCatchupDateFilterStore)();
    const { resetToDefault: resetToDefault } = (0, $16tNb.usePageCatchupDateFilterStoreActions)();
    const { setActiveActionFollowUpContext: setActiveActionFollowUpContext } = (0, $2YmgJ.useConversationActionsStoreActions)();
    const previousFilterState = (0, $42omo.useRef)(filterState.selectedPeriod);
    (0, $42omo.useEffect)(()=>{
        if (previousFilterState.current !== filterState.selectedPeriod && previousFilterState.current !== undefined) {
            resetStreaming();
            currentAnswerChunk.current = 0;
            isStreamingDone.current = false;
            isStreamInitializationDone.current = false;
            setHideMetadata(true);
        }
        previousFilterState.current = filterState.selectedPeriod;
    }, [
        filterState.selectedPeriod,
        resetStreaming
    ]);
    const analyticsProperties = {
        source: 'pageCatchup',
        additionalAnalyticsAttributes: {
            subSource: source
        }
    };
    const originalContentVersion = selectedVersions ? Math.min(...Array.from(selectedVersions)) : 0;
    const revisedContentVersion = selectedVersions ? Math.max(...Array.from(selectedVersions)) : 0;
    const hasSelectedVersions = selectedVersions && selectedVersions.size > 1 && source === 'pageHistory';
    const isStreamingDone = (0, $42omo.useRef)(false);
    const isStreamInitializationDone = (0, $42omo.useRef)(false);
    const timeToFirstAnswerPart = (0, $42omo.useRef)(0);
    const { trackAIInteractionInit: trackAIInteractionInit, trackAIResultView: trackAIResultView, trackAIResultError: trackAIResultError, trackAIResultAction: trackAIResultAction, trackAIInteractionDismiss: trackAIInteractionDismiss } = (0, $fYQcF.useAIEventsInstrumentation)();
    const hasQueryParamOpenSet = $5811907f4df745b5$var$useOpenContentCatchupParam() === 'true';
    const contentTypeEnum = contentType === 'page' ? (0, $551036f28c08b5b8$export$fe6033382a69eea9).PAGE : (0, $551036f28c08b5b8$export$fe6033382a69eea9).BLOGPOST;
    const timeframeLength = filterState.selectedPeriod === 'since-last-visit' ? undefined : filterState.selectedPeriod;
    let updateType;
    if (hasSelectedVersions) updateType = 'BETWEEN_VERSIONS';
    else if (timeframeLength) updateType = 'SINCE_X_DAYS';
    else if ((0, $9wGTI.fg)('convo-ai_should_disable_inline_linking_for_llama')) updateType = 'SINCE_LAST_VIEWED';
    else updateType = 'SINCE_LAST_VIEWED_MARKDOWN';
    const { data: data, error: defaultMetaDataError } = (0, $xQxzY.useQuery)($5811907f4df745b5$var$PageCatchupVersionDiffWrapperComponentPageCatchupMetadataQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            endTimeMs: dateInMs,
            updateType: updateType
        },
        skip: hasSelectedVersions
    });
    const { data: versionDiffMetadata, error: versionDiffMetadataError } = (0, $xQxzY.useQuery)($5811907f4df745b5$var$PageCatchupVersionDiffWrapperComponentPageCatchupVersionDiffMetadataForContentQuery, {
        variables: {
            contentId: contentId,
            contentType: contentTypeEnum,
            originalContentVersion: originalContentVersion,
            revisedContentVersion: revisedContentVersion
        },
        skip: !hasSelectedVersions
    });
    const metaDataError = defaultMetaDataError || versionDiffMetadataError;
    const isVersionDiffEmpty = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.isDiffEmpty ?? false;
    const versionDiffUsers = versionDiffMetadata?.catchupVersionDiffMetadataForContent?.users ?? [];
    const versionDiffEditors = (0, $676d15788c30fd82$export$2364cf53dded03dd)(versionDiffUsers);
    const setIsStreamingDone = ()=>{
        isStreamingDone.current = true;
    };
    const setIsStreamInitializationDone = ()=>{
        isStreamInitializationDone.current = true;
    };
    const onShowMoreClick = (0, $42omo.useCallback)(()=>{
        trackAIResultAction('showMoreClicked');
    }, [
        trackAIResultAction
    ]);
    const [request, config] = (0, $42omo.useMemo)(()=>{
        return (0, $9ed1632df7d8fede$export$60847e9d6d4c2441)({
            contentAri: pageAri ?? '',
            locale: locale,
            updateType: updateType,
            endTimeMs: dateInMs,
            timeframeLength: timeframeLength,
            selectedVersions: selectedVersions,
            enablePartialJson: !hasSelectedVersions,
            enableFollowUp: isRovoEnabled && (0, $9wGTI.fg)('page-catchup-follow-up-enabled')
        });
    }, [
        pageAri,
        locale,
        updateType,
        dateInMs,
        selectedVersions,
        timeframeLength,
        hasSelectedVersions,
        isRovoEnabled
    ]);
    const updateInlineLinkingContent = (0, $42omo.useCallback)((answerPartContent)=>{
        const fullContent = (0, $c393a02d5f46acb0$export$c476676a5dd91e06)(answerPartContent);
        const newContent = fullContent.slice(lastProcessedLength);
        if (buffer.join('') !== newContent && newContent.length > 0) updateBuffer(newContent);
        setLastProcessedLength(fullContent.length);
    }, [
        updateBuffer,
        setLastProcessedLength,
        lastProcessedLength,
        buffer
    ]);
    const onStateChange = (0, $42omo.useCallback)((state)=>{
        switch(state.responseState){
            case (0, $kAaxz.ConvoAIResponseState).Initialization:
                if (state.content === null) {
                    experienceTracker.start({
                        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                    });
                    (0, $f249c720b72bd2f9$export$42c905138efbcdac).start();
                    trackAIInteractionInit();
                    timeToFirstAnswerPart.current = Date.now();
                }
                break;
            case (0, $kAaxz.ConvoAIResponseState).Error:
                const { status_code: status_code, message_template: message_template } = state.error.message;
                (0, $f249c720b72bd2f9$export$42c905138efbcdac).stop();
                trackAIResultError({
                    aiErrorCode: status_code,
                    aiErrorMessage: message_template
                });
                setIsStreamingDone();
                break;
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
                if (!isStreamInitializationDone.current) {
                    setIsStreamInitializationDone();
                    createAnalyticsEvent({
                        type: 'sendTrackEvent',
                        data: {
                            action: 'streamReceived',
                            actionSubject: 'pageCatchup',
                            source: source ?? 'page',
                            actionSubjectId: 'pageCatchupDialog',
                            attributes: {
                                contentId: contentId,
                                timeToFirstAnswerPartInMs: Date.now() - timeToFirstAnswerPart.current
                            }
                        }
                    }).fire();
                }
                if (currentAnswerChunk.current !== state.answerChunkIndex) updateInlineLinkingContent(state.content);
                currentAnswerChunk.current = state.answerChunkIndex;
                break;
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                (0, $f249c720b72bd2f9$export$42c905138efbcdac).stop();
                createAnalyticsEvent({
                    type: 'sendScreenEvent',
                    data: {
                        name: 'pageCatchupDialog',
                        attributes: {
                            contentId: contentId,
                            aiInteractionId: aiInteractionId,
                            hasQueryParamOpenSet: hasQueryParamOpenSet
                        }
                    }
                }).fire();
                trackAIResultView();
                setIsStreamingDone();
                break;
            default:
                break;
        }
    }, [
        trackAIResultError,
        updateInlineLinkingContent,
        createAnalyticsEvent,
        contentId,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultView,
        experienceTracker,
        trackAIInteractionInit,
        source
    ]);
    const [{ content: content, responseState: responseState, error: streamSummaryError, followUpContent: followUpContent }] = (0, $d3UlG.useConvoAIStreaming)(request, config, onStateChange);
    const handleContainerClick = (0, $42omo.useCallback)((e)=>{
        const target = e.target;
        const linkElement = target.closest('a[id="#page-catchup-text-fragment"]');
        if (linkElement) trackAIResultAction('inlineLinkClicked');
    }, [
        trackAIResultAction
    ]);
    (0, $42omo.useEffect)(()=>{
        if (responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse || responseState === (0, $kAaxz.ConvoAIResponseState).FollowUp) {
            const container = document.querySelector('div[data-testid="object-sidebar-panel-body"]');
            if (container) {
                container.addEventListener('click', handleContainerClick);
                return ()=>{
                    container.removeEventListener('click', handleContainerClick);
                };
            }
        }
    }, [
        responseState,
        handleContainerClick
    ]);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'dwelled',
                    actionSubject: 'pageCatchup',
                    source: source ?? 'page',
                    actionSubjectId: 'pageCatchupDialog',
                    attributes: {
                        contentId: contentId,
                        dwellTime: getDwellTime(),
                        aiInteractionId: aiInteractionId,
                        hasQueryParamOpenSet: hasQueryParamOpenSet
                    }
                }
            }).fire();
            if (!isStreamInitializationDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'stream_initialization'
                }
            });
            else if (!isStreamingDone.current) trackAIInteractionDismiss({
                attributes: {
                    dismissTiming: 'answer_part_streaming'
                }
            });
        }; // we only want to run this effect on un-mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $42omo.useEffect)(()=>{
        return ()=>{
            resetToDefault();
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $42omo.useEffect)(()=>{
        if (responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse) {
            if (hideMetadata) setHideMetadata(false);
        }
    }, [
        responseState,
        hideMetadata
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!allowCustomFollowUp || hasSelectedVersions || !isStreamingDone.current) return;
        setActiveActionFollowUpContext({
            available: true,
            fetch: ()=>Promise.resolve((0, $955e1fd2497cca79$export$19fc7a97b20ab78e)(contentPath, inlineLinkingContent, formatMessage))
        });
    }, [
        allowCustomFollowUp,
        hasSelectedVersions,
        inlineLinkingContent,
        contentPath,
        formatMessage,
        setActiveActionFollowUpContext
    ]);
    const lastVisitedOnDate = (0, $b00440823166005e$export$757dbcc1bd42832)(data?.catchupEditMetadataForContent?.lastVisitTimeISO, locale);
    const hasVersionChangedSinceLastVisit = data?.catchupEditMetadataForContent?.hasVersionChangedSinceLastVisit ?? false;
    const users = data?.catchupEditMetadataForContent?.users ?? [];
    const defaultEditors = (0, $676d15788c30fd82$export$2364cf53dded03dd)(users);
    const editors = source === 'pageHistory' ? versionDiffEditors : defaultEditors;
    const pageVersion = data?.content?.nodes?.[0]?.version?.number ?? -1;
    const { versionHistoryLink: versionHistoryLink } = (0, $dbb424c9806aaca2$export$3042bbbffe78f13c)(contentId, spaceKey, pageVersion);
    const onVersionHistoryLinkClick = (0, $42omo.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'pageCatchup',
                action: 'clicked',
                actionSubject: 'link',
                actionSubjectId: 'pageCatchupVersionHistoryLink',
                attributes: {
                    contentId: contentId,
                    aiInteractionId: aiInteractionId,
                    hasQueryParamOpenSet: hasQueryParamOpenSet
                }
            }
        }).fire();
        trackAIResultAction('versionHistoryLinkClick');
    }, [
        contentId,
        createAnalyticsEvent,
        aiInteractionId,
        hasQueryParamOpenSet,
        trackAIResultAction
    ]);
    const pageCatchupComponentProps = {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey,
        lastVisitedOnDate: lastVisitedOnDate,
        editors: editors,
        ref: catchUpContentRef,
        hideMetadata: !hasSelectedVersions ? responseState === (0, $kAaxz.ConvoAIResponseState).AnswerPart || isBufferStreaming : hideMetadata,
        versionHistoryLink: versionHistoryLink,
        onVersionHistoryLinkClick: onVersionHistoryLinkClick,
        hasVersionChangedSinceLastVisit: hasVersionChangedSinceLastVisit,
        onShowMoreClick: onShowMoreClick,
        source: source,
        isVersionDiffEmpty: isVersionDiffEmpty,
        isInObjectSidebar: isInObjectSidebar,
        isInNewContentHistory: isInNewContentHistory,
        updateType: updateType,
        timeframeLength: timeframeLength,
        isRovoEnabled: isRovoEnabled,
        setIsOpen: setIsOpen,
        contentPath: contentPath
    };
    const renderPageCatchupComponent = (contentToRender, followUpContentToRender)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b47380d9a1361e15$export$c463287b61deee24), {
            ...pageCatchupComponentProps,
            content: contentToRender,
            followUpContent: allowCustomFollowUp ? undefined : followUpContentToRender,
            showAIDisclaimer: showAIDisclaimer
        });
    const renderContent = ()=>{
        switch(responseState){
            case (0, $kAaxz.ConvoAIResponseState).Initialization:
                return isInObjectSidebar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gdv5Z.default), {
                    paddingInline: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8LJEA.AISummaryLoading), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $au4KV.AIStreamLoading), null);
            case (0, $kAaxz.ConvoAIResponseState).Error:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ly2zj.SmartsSummaryErrorComponent), {
                    analyticsProperties: analyticsProperties,
                    errorFromApolloOrStream: streamSummaryError,
                    contentId: contentId,
                    experienceName: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE)
                });
            case (0, $kAaxz.ConvoAIResponseState).AnswerPart:
            case (0, $kAaxz.ConvoAIResponseState).FollowUp:
            case (0, $kAaxz.ConvoAIResponseState).FinalResponse:
                const isStreamingInProgress = !isStreamingDone.current;
                const followUpContentToRender = isStreamingInProgress ? undefined : followUpContent;
                if (updateType === 'SINCE_LAST_VIEWED') return renderPageCatchupComponent(content || '', followUpContentToRender);
                else if (!hasSelectedVersions) return renderPageCatchupComponent(inlineLinkingContent, followUpContentToRender);
                return renderPageCatchupComponent(content || '', followUpContentToRender);
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        className: (0, $gMc0m.default)([
            "_4t3i1osq _ggmhs13h"
        ])
    }, isInObjectSidebar || isInNewContentHistory ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dOOm2.AIBorder), {
        loading: responseState === (0, $kAaxz.ConvoAIResponseState).Initialization
    }, metaDataError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: metaDataError
    }), renderContent(), responseState === (0, $kAaxz.ConvoAIResponseState).FinalResponse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.AI_CONTENT_CATCHUP_EXPERIENCE),
        attributes: {
            source: source
        }
    })));
};


const $82cc03f71f27d09d$export$22f83c0ec7a66a2 = (props)=>{
    const aiAnalyticsConfig = {
        product: 'confluence',
        subproduct: 'confluence',
        source: props.source ?? 'confluencePage',
        aiFeatureName: 'pageCatchup',
        proactiveGeneratedAI: 0,
        userGeneratedAI: 1
    };
    const pageCatchupComponent = (0, $9wGTI.fg)('confluence_ai_page_catchup_convo_ai_migration') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5811907f4df745b5$export$f663be73c38b26f1), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $68e47fc55df08327$export$4c578b92894b49da), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $2Rith.AIEventsInstrumentationProvider), {
        config: aiAnalyticsConfig
    }, pageCatchupComponent));
};
module.exports["PageCatchupComponentWithErrorBoundary"] = $82cc03f71f27d09d$export$22f83c0ec7a66a2;

});

parcelRegister("bqnQm", function(module, exports) {
/* ContributorsOverflow.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $esRft = parcelRequire("esRft");


var $1s5hv = parcelRequire("1s5hv");

var $d8SNb = parcelRequire("d8SNb");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $ccHMk = parcelRequire("ccHMk");

const $b398b42400d15ac1$var$i18n = (0, $cgtv4.defineMessages)({
    anonymousUser: {
        id: "content-history-new-contributors-overflow.contributors-overflow.anonymous.user",
        defaultMessage: "Anonymous user"
    },
    userOverflow: {
        id: "content-history-new-contributors-overflow.contributors-overflow.user.overflow",
        defaultMessage: "+ {userCount} {userCount, plural, one {other} other {others}}"
    },
    showLess: {
        id: "content-history-new-contributors-overflow.contributors-overflow.user.overflow.show.less",
        defaultMessage: "Show less"
    }
});
const $b398b42400d15ac1$var$styles = {
    buttonWrapper: "_1bsb53f4",
    avatarStack: "_zulpu2gc",
    avatarGrid: "_zulpu2gc _yv0ewxkt"
};
const $b398b42400d15ac1$var$MAX_SHOWN_USERS = 6;
const $b398b42400d15ac1$export$dd289f99c75d956c = ({ contributors: contributors, maxShownUsers: maxShownUsers = $b398b42400d15ac1$var$MAX_SHOWN_USERS, shouldUseGridStyles: shouldUseGridStyles })=>{
    const intl = (0, $8C5kA.default)();
    const anonymousUser = intl.formatMessage($b398b42400d15ac1$var$i18n.anonymousUser);
    const [showOverflow, setShowOverflow] = (0, $42omo.useState)(false);
    const remainingUserCount = contributors.length - maxShownUsers;
    const UserAvatar = ({ user: user })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
            gap: "space.050",
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $esRft.default), {
            testId: "version-history-avatar",
            size: "xsmall",
            src: user?.src,
            name: user?.name || anonymousUser,
            borderColor: "var(--ds-background-neutral-subtle, #00000000)"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $iXCQx.default), {
            testId: "version-history-display-name",
            color: "color.text.subtle"
        }, user?.name || anonymousUser));
    const userInfo = contributors.slice(0, maxShownUsers).map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(UserAvatar, {
            key: `displayed-user-${index}`,
            user: user
        }));
    const overflowUserInfo = contributors.slice(maxShownUsers).map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(UserAvatar, {
            key: `overflow-user-${index}`,
            user: user
        }));
    const AvatarsWrapper = shouldUseGridStyles ? (0, $d8SNb.default) : (0, $eyWa4.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eyWa4.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(AvatarsWrapper, {
        testId: `avatars-wrapper-${shouldUseGridStyles ? 'grid' : 'stack'}`,
        xcss: shouldUseGridStyles ? $b398b42400d15ac1$var$styles.avatarGrid : $b398b42400d15ac1$var$styles.avatarStack
    }, userInfo, showOverflow && overflowUserInfo), remainingUserCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1s5hv.default), {
        xcss: (0, $1Whri.cx)($b398b42400d15ac1$var$styles.buttonWrapper)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
        testId: "overflow-button",
        spacing: "compact",
        onClick: (event)=>{
            event.stopPropagation(); // Prevent click on parent section button when we click the contributors button
            setShowOverflow((prevShowOverflow)=>!prevShowOverflow);
        }
    }, showOverflow ? intl.formatMessage($b398b42400d15ac1$var$i18n.showLess) : intl.formatMessage($b398b42400d15ac1$var$i18n.userOverflow, {
        userCount: remainingUserCount
    }))));
};
module.exports["ContributorsOverflow"] = $b398b42400d15ac1$export$dd289f99c75d956c;

});

parcelRegister("86vQj", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bQm3c = parcelRequire("bQm3c");


var $9wGTI = parcelRequire("9wGTI");


var $gL2Cx = parcelRequire("gL2Cx");

const $331fad0aae4cd917$export$9321895a4e785c58 = ({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, source: source, selectedVersions: selectedVersions, contentPath: contentPath })=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const isDisabled = selectedVersions.size < 2;
    const shouldRenderPageCatchupPopup = isAdminHubAIEnabled && (0, $9wGTI.fg)('cc_ai_consumption_page_catchup_in_page_history');
    if (shouldRenderPageCatchupPopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gL2Cx.PageCatchupPopupComponent), {
        contentId: contentId,
        contentType: contentType,
        spaceKey: spaceKey ?? '',
        isDisabled: isDisabled,
        source: source,
        selectedVersions: selectedVersions,
        contentPath: contentPath
    });
    return null;
};
module.exports["PageCatchupPopupForPageHistory"] = $331fad0aae4cd917$export$9321895a4e785c58;

});

parcelRegister("hPavA", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cgtv4 = parcelRequire("cgtv4");

var $gtD4K = parcelRequire("gtD4K");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $4AkKf = parcelRequire("4AkKf");


var $1qfLF = parcelRequire("1qfLF");


var $16tNb = parcelRequire("16tNb");

const $bae17ae1861f40f9$var$i18n = (0, $cgtv4.defineMessages)({
    filterSinceLastVisited: {
        id: "page-catchup.filter.since-last-visited",
        defaultMessage: "Since last visited"
    },
    filterToday: {
        id: "page-catchup.filter.today",
        defaultMessage: "Today"
    },
    filterPast7Days: {
        id: "page-catchup.filter.past7days",
        defaultMessage: "Past 7 Days"
    },
    filterPast14Days: {
        id: "page-catchup.filter.past14days",
        defaultMessage: "Past 14 Days"
    },
    filterPast30Days: {
        id: "page-catchup.filter.past30days",
        defaultMessage: "Past 30 Days"
    },
    filterAllTime: {
        id: "page-catchup.filter.alltime",
        defaultMessage: "All time"
    },
    filterButtonLabel: {
        id: "page-catchup.filter.button.label",
        defaultMessage: "Filter changes"
    }
});
const $bae17ae1861f40f9$export$b36199eb679cf8aa = ()=>{
    const filterActions = (0, $16tNb.usePageCatchupDateFilterStoreActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $52EPl.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1qfLF.default), {
                ...props,
                testId: "page-catchup-filter-button",
                appearance: "subtle",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bae17ae1861f40f9$var$i18n.filterButtonLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($4AkKf))),
                ref: triggerRef
            }),
        shouldRenderToParent: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ahaN7.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>filterActions.changeToPeriod('since-last-visit')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bae17ae1861f40f9$var$i18n.filterSinceLastVisited)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>filterActions.changeToPeriod('ONE_DAY_AGO')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bae17ae1861f40f9$var$i18n.filterToday)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>filterActions.changeToPeriod('ONE_WEEK_AGO')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bae17ae1861f40f9$var$i18n.filterPast7Days)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>filterActions.changeToPeriod('TWO_WEEKS_AGO')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bae17ae1861f40f9$var$i18n.filterPast14Days)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>filterActions.changeToPeriod('ONE_MONTH_AGO')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bae17ae1861f40f9$var$i18n.filterPast30Days)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dAYOx.default), {
        onClick: ()=>filterActions.changeToPeriod('ALL_TIME')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), $bae17ae1861f40f9$var$i18n.filterAllTime))));
};
module.exports["FilterComponent"] = $bae17ae1861f40f9$export$b36199eb679cf8aa;

});

parcelRegister("16tNb", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $ed3cba565daf8015$var$initialState = {
    selectedPeriod: 'since-last-visit'
};
const $ed3cba565daf8015$var$actions = {
    changeToPeriod: (selectedPeriod)=>{
        return ({ setState: setState })=>{
            setState({
                selectedPeriod: selectedPeriod
            });
        };
    },
    resetToDefault: ()=>{
        return ({ setState: setState })=>{
            setState({
                selectedPeriod: $ed3cba565daf8015$var$initialState.selectedPeriod
            });
        };
    }
};
const $ed3cba565daf8015$export$bb67dd48145780bf = (0, $1P1Tu.createStore)({
    initialState: $ed3cba565daf8015$var$initialState,
    actions: $ed3cba565daf8015$var$actions
});
const $ed3cba565daf8015$export$d1392fd68807b10e = (0, $9zUhf.createHook)($ed3cba565daf8015$export$bb67dd48145780bf);
const $ed3cba565daf8015$export$8b547898236c0dba = (0, $9zUhf.createActionsHook)($ed3cba565daf8015$export$bb67dd48145780bf);
module.exports["usePageCatchupDateFilterStore"] = $ed3cba565daf8015$export$d1392fd68807b10e;
module.exports["usePageCatchupDateFilterStoreActions"] = $ed3cba565daf8015$export$8b547898236c0dba;

});


//# sourceMappingURL=ObjectSidebarControl.1a647e7c.js.map
